/**
 * Chain the given promises, one after the other.
 *
 * @template A
 * @param {Array<function(): Promise<A>>} initialThunks
 * @return {Promise<Array<A>>}
 */
export const sequenceThunks = (initialThunks) => {
  return initialThunks.reduce((accPromise, next) => {
    return accPromise.then((acc) => {
      return next().then((result) => {
        return [...acc, result]
      })
    })
  }, Promise.resolve([]))
}
